import React, { Component } from 'react';
import Navigable from './Navigable'
import TextEditor from '../editor/LazyTextEditor'

import CodeMirror from 'codemirror'
import moment from 'moment'
import ReactDOM from 'react-dom';
import { incrementActiveCount, decrementActiveCount, collectActiveCount } from '../quark/collect'
// import PaymentForm from './Payment'

var draggedObject;
export default class Lombax extends Navigable {
    constructor(props){
        super(props)
        var expanded = props.default_expanded && !this.loop()
        this.state = { hover: false, expanded: expanded  }
    }
    setExpand(state){
        var {path, line, cursor} = this.props;
        if(!this.loop()){
            this.setState({ expanded: state });
            // cursor.set('expand', state)
            // console.log(cursor.get())
        }
    }
    bulletEnter(e){ 
        this.setState({ hover: true }) 
        // var { cursor } = this.props;
        // cursor.set('hover', true)
    }
    bulletLeave(e){ 
        this.setState({ hover: false }) 
        // var { cursor } = this.props;
        // cursor.set('hover', false)
    }
    
    isExpand(){
        return this.state.expanded
        // var { cursor } = this.props;
        // return !!cursor.get('expand')
    }
    isHover(){
        // var { cursor } = this.props;
        return this.state.hover
        // return !!cursor.get('hover')
    }

    toggleCollapse(){
        this.setExpand(!this.isExpand())
        this.setFocus(null)
    }
    loop(){
        var {path, line} = this.props;
        return path.some(k => quark.line_is_equal(k, line))        
    }
    cursorOffset(){ if(this.input()) return this.input().cursorOffset() }
    focusNext(){ if(super.focusNext(this.cursorOffset())) this.blur(); }
    focusPrev(){ if(super.focusPrev(this.cursorOffset())) this.blur(); }
    input(){ return this.refs.input }
    focus(front = false, offset){ if(this.input()) this.input().focus(front, offset) }
    blur(){ if(this.input()) this.input().blur() }


    navigateSelected(){
        var {path, line} = this.props;
        if(path.length > 0){
            if(line.type == 'text'){
                quark.set_root_text(quark.tok(line.id))
            }else if(line.type == 'edge'){
                quark.set_root_text(quark.tok(line.ref))
            }else{
                var cm = this.input().cm,
                    token = cm.getTokenAt(cm.getCursor());
                if(token.string.match(/<ref-.*>/)){
                    quark.set_root_text(token.string.match(/<ref-.*>/)[0])
                }else if(token.type == 'entity'){
                    quark.set_root_text(quark.tok(fid(token.string.trim())))
                }else if(line.type == 'cluster'){
                    if(enlist(line).length == 1){
                        quark.set_root_text(quark.tok(enlist(line)[0].ref))
                    }else{
                        var nav_index = 0;
                        try {
                            var text = cm.getValue(),
                                cur = cm.getCursor();
                            
                            var nav_index = text.slice(0, cur.ch).split(':')[1].split(',').length - 1
                        } catch (err) {
                            console.warn(err)
                        }
                        quark.set_root_text(quark.tok(enlist(line)[nav_index].ref))
                    }
                    
                }else{
                    console.warn('not handled', line, token)
                }
            }
            this.setFocus("__root__")
            globalUpdate()
        }
    }
    backspace(){
        var {path, line} = this.props;
        if((quark.get_text(line) == '' ||
            (quark.get_text(line) == ':' && line.type == 'edge' 
                && enlist(get(line.parent)).length > 1)
        ) && line.id != '__root__'){ // backspace
            
            quark.remove_entity(line, false)
            quark.checkpoint()
            this.focusPrev()
            globalUpdate()
        }else return CodeMirror.Pass;
    }
    down(cm){
        if(cm.findPosV(cm.getCursor(), 1, 'line').hitSide){
            this.focusNext() 
        }else{
            return CodeMirror.Pass    
        }
    }
    up(cm){
        if(cm.findPosV(cm.getCursor(), -1, 'line').hitSide){
            this.focusPrev()    
        }else{
            return CodeMirror.Pass    
        }
    }
    makeScratchpad(){
        var root = quark.new_scratchpad()
        var children = quark.get_children(root);
        if(children.length == 0){
            this.setFocus(quark.create_child(root))
            quark.checkpoint()
        }
        globalUpdate()
    }

    toggleDown(){
        if(!this.isExpand()) this.toggleCollapse();
        this.focusNext()
    }
    toggleUp(){
        if(this.parent() && this.parent().isExpand())
            this.parent().toggleCollapse();
        this.focusPrev()
    }
    focusSearch(){
        this.setFocus('__root__')
        globalUpdate()
        this.root().input().cm.execCommand('selectAll')
    }
    keyMap = {
        "Ctrl-Space": "autocomplete",
        "Enter": cm => this.handleEnter(false),
        "Shift-Enter": cm => this.handleEnter(true),
        "Backspace": this.backspace.bind(this),
        "Tab": cm => this.handleTab(false),
        "Shift-Tab": cm => this.handleTab(true),
        "Down": this.down.bind(this),
        "Up": this.up.bind(this),

        "Cmd-Enter": this.navigateSelected.bind(this),
        "Ctrl-Enter": this.navigateSelected.bind(this),
        
        "Cmd-Down": this.toggleDown.bind(this),
        "Ctrl-Down": this.toggleDown.bind(this),
        
        "Cmd-Up": this.toggleUp.bind(this),
        "Ctrl-Up": this.toggleUp.bind(this),

        "Cmd-E": this.focusSearch.bind(this),
        "Ctrl-E": this.focusSearch.bind(this),

        "Cmd-D": this.makeScratchpad.bind(this),
        "Ctrl-D": this.makeScratchpad.bind(this),
    }
    handleEnter(shift){
        var {path, line} = this.props;
        if(shift || path.length == 0){
            if(line.type == 'cluster' && line.predicate && quark.enlist(line).length == 1){
                if(quark.enlist(line)[0].ref){
                    this.setFocus(quark.create_child(quark.enlist(line)[0]))
                }else{
                    this.setFocus(line.list[0])
                }
                this.blur()
                quark.checkpoint()
                this.setExpand(true)
                
            }else{
                this.setFocus(quark.create_child(line))
                this.blur()
                quark.checkpoint()
                this.setExpand(true)
            }
        }else{
            if(this.input().cm.getCursor().ch == 0 && this.input().getText().length > 1){
                var parent = path[path.length - 1]
                // if we're at the start of the line, pressing enter
                // actually inserts something before the current line
                // rather than after
                var ref = '^' + line.id;
                this.setFocus(quark.create_child(parent, ref))
                this.blur()
                quark.checkpoint()
                globalUpdate()
                return
            }
            return CodeMirror.Pass

            // var parent = path[path.length - 1]
            // // if we're at the start of the line, pressing enter
            // // actually inserts something before the current line
            // // rather than after
            // var ref = (this.input().cm.getCursor().ch == 0 && 
            //            this.input().getText().length > 1 ? '^' : '') + line.id;
            // this.setFocus(quark.create_child(parent, ref))
            // this.blur()
            // quark.checkpoint()
        }

        globalUpdate()
    }
    handleTab(shift){
        var {path, line} = this.props;
        // if(line.type != 'text') return; 
        // clusters and shit are dangerous
        var oldtext = quark.get_text(line);
        oldtext = quark.remove_refs(oldtext);

        if(shift){
            var parent = path[path.length - 1]
            var metaparent = path[path.length - 2]
            if(metaparent && !this.loop() && (
                ['text', 'edge', 'root'].includes(metaparent.type) ||
                (metaparent.type == 'cluster' && metaparent.predicate == '')
            )){
                quark.detach_entity(line, false)                
                quark.insert_relative(metaparent, parent.id, line)
                quark.set_text(metaparent, quark.get(line.id), oldtext)


                // regenerate the parent
                // quark.set_text(parent, line, quark.get_text(parent))
                this.setFocus(line.id)
                console.warn('handled untab', metaparent, parent)
                
                quark.checkpoint()
            }else if(parent.type == 'edge' && 
                    metaparent.type == 'cluster' &&
                    metaparent.parent != '__root__' &&
                    quark.enlist(metaparent).length == 1 ){
                var hyperparent = quark.get(metaparent.parent);

                quark.detach_entity(line, false)                
                quark.insert_relative(hyperparent, metaparent.id, line)
                quark.set_text(hyperparent, quark.get(line.id), oldtext)

                this.setFocus(line.id)
                console.warn('quarkskip untab', hyperparent, parent)
                
                quark.checkpoint()
            }else if(line.type == 'text' && 
                    parent.type == 'text' &&
                    quark.enlist(line).length == 0 &&
                    oldtext.trim() == ''){

                quark.remove_entity(line, false)
                var new_id = quark.create_child(metaparent);
                
                quark.set_text(metaparent, quark.get(new_id), oldtext)
                quark.checkpoint()

                // prev.setExpand(true)

                console.warn('lightspeed untab', hyperparent, parent)

            // using this to set tab is a pretty bad idea
            // }else if(parent.id == '__root__' && 
            //         parent.type == 'root' && 
            //         get(parent.ref).type == 'text' &&
            //         quark.get_children(line).length == 0 &&
            //         this.getIndex() == 0 &&
            //         line.type == 'text'){
                
            //     console.log('set title', line.text)

            //     if(this.nextSibling()){
            //         this.focusNext()
            //     }else{
            //         this.setFocus(quark.create_child(parent))
            //     }
            //     quark.remove_entity(line, false)
            //     quark.core.update(parent.ref, {
            //         text: line.text
            //     })
            //     quark.checkpoint()

            }else{
                console.warn('unhandled untab', metaparent, parent)
                this.setFocus(null);
            }
        }else{
            var prev = this.prevSibling()
            var parent = prev && prev.props.line;
            if(prev && !this.loop() && (
                ['text', 'edge', 'root'].includes(parent.type) ||
                (parent.type == 'cluster' && parent.predicate == '')
            )){
                quark.detach_entity(line, false)
                quark.insert_relative(parent, null, line)
                quark.set_text(parent, quark.get(line.id), oldtext)
                this.setFocus(line.id)

                quark.checkpoint()
                prev.setExpand(true)

            }else if(prev && line.type == "text" && 
                        oldtext.trim() == '' && 
                        quark.enlist(line).length == 0){
                quark.remove_entity(line, false)
                var new_id = quark.create_child(parent);
                this.setFocus(new_id)
                quark.set_text(parent, quark.get(new_id), oldtext)
                quark.checkpoint()
                prev.setExpand(true)
            }else this.setFocus(null);
        }
        globalUpdate()
    }
    componentDidMount(){
        var {line} = this.props;
        if(line.id == dofocus) this.focus();
        incrementActiveCount(line)
    }
    componentWillUnmount(){
        var {line} = this.props;
        decrementActiveCount(line)
        collectActiveCount()
    }
    componentDidUpdate(prevProps){
        var {line} = this.props;
        if(line.id == dofocus) this.focus();

        decrementActiveCount(prevProps.line)
        incrementActiveCount(line)
        collectActiveCount()
    }
    setFocus(id){
        dofocus = id
    }
    onChange(text){
        var {path, line} = this.props;
        var parent = path[path.length - 1]
        var oldtext = quark.get_text(line);

        if(text == oldtext) return;

        if(text == '' && line.type == 'edge' && quark.EDGE_AUTOCOLON) 
            text = ':';

        
        var ref = line.id;

        text.split('\n').forEach((text_line, i) => {
            // console.log(text_line, i)

            if(i > 0){
                if(line.id.startsWith('fake-')) return;
                
                var child = quark.create_child(parent, ref)
                quark.set_text(parent, quark.get(child), text_line)

                ref = child
                quark.checkpoint()
                // console.log(path, child)
                return
            }

            quark.set_text(parent, line, text_line)
            if(quark.check_path(path.concat([line]))){
                quark.checkpoint()
            }else{
                console.warn("path sustainability invariant violation")
                quark.stash()
            }

            // i don't remember what cases end up triggering this
            // if(!line.id.startsWith('fake-') && line.id != '__root__'){
            //     var new_text = quark.get_text(quark.get(line.id));
            //     if(new_text == oldtext){
            //         // require('../lib/beep.js')();
            //         console.warn('beep')
            //     }
            // }
        })

        if(ref != line.id){
            this.blur()
            this.setFocus(ref)    

        }else{
            this.setFocus(null)

        }
        

        //     if(i === 0){
        //         quark.set_text(parent, line, text_line)
        //         if(quark.check_path(path.concat([line]))){
        //             quark.checkpoint()
        //         }else{
        //             console.warn("path sustainability invariant violation")
        //             quark.stash()
        //         }

        //         // i don't remember what cases end up triggering this
        //         if(!line.id.startsWith('fake-') && line.id != '__root__'){
        //             var new_text = quark.get_text(quark.get(line.id));
        //             if(new_text == oldtext){
        //                 require('../lib/beep.js')();
        //             }    
        //         }
        //     }else{
        //         var parent = path[path.length - 1]
                
        //         // var new_id = quark.create_child(parent, ref);
        //         console.log(parent)

        //         // ref = new_id;
        //         // quark.set_text(parent, quark.get(new_id), text_line)

        //         // this.setFocus(new_id)
        //     }

        //     // var parent = path[path.length - 1]
        //     // var ref = (this.input().cm.getCursor().ch == 0 && 
        //     //            this.input().getText().length > 1 ? '^' : '') + line.id;
        //     // this.setFocus(quark.create_child(parent, ref))
        //     // this.blur()
        //     // quark.checkpoint()
        //     // console.log('hey look at this text line')


        // })

        
        

        // if(!(line.id.startsWith('fake-')  || line.id == '__root__')){
        //     var el = quark.get(line.id);
        //     if(el){
        //         var compare = quark.remove_refs(quark.get_text(el));
        //         if(compare != quark.remove_refs(text) ){
        //             console.warn("regeneration violation", compare, quark.remove_refs(text));    
        //         }
        //     }else{
        //         console.warn('element does not exist', line.id)
        //     }     
        // }
        
        globalUpdate()   
    }

    render_children(children){
        var {line, path} = this.props;
        console.assert(children)
        var default_expanded = children.length == 1 
            && children[0].type == 'edge'
        // cursor={this.props.cursor.select('children', k.id)}
        return children.map((k, i) => {
            return <Lombax 
                ref={"child-" + i}
                index={i}
                parent={this}
                default_expanded={default_expanded}
                line={k}
                path={path.concat([line])}
                key={k.id} />
        })
    }

    render_node(){
        var {line, path} = this.props;
        return (
            <div className="node">
                <TextEditor 
                    ref="input"
                    lazy={this.props.index > 1}
                    line={line}
                    path={path}
                    keyMap={this.keyMap}
                    onChange={this.onChange.bind(this)}
                    text={quark.get_text(line)} />
            </div>
        )

        // {(line.type == 'text' && !expanded && children.length > 0 
        //   && children[0].type == 'text' ) ? 
        //     <div className="node-notes">{
        //         children[0].text
        //     }</div> : null}
    }

    dragStart(e){
        var {line, path} = this.props;
        if(this.isHover()){
            e.dataTransfer.effectAllowed = 'move'
            draggedObject = line.id;
            try {
                e.dataTransfer.setData('text/html', null);
            } catch (ex) {
                e.dataTransfer.setData('text', '');
            }
            e.stopPropagation()
        }else{
            e.preventDefault()
        }
        
    }

    dragEnd(e){
        draggedObject = null;
        globalUpdate()
    }

    dragOver(e){
        e.preventDefault();
        e.stopPropagation()

        var over = e.currentTarget
        // var relX = e.clientX - over.getBoundingClientRect().left;
        var relY = e.clientY - over.getBoundingClientRect().top;
        var height = over.offsetHeight / 2;
        var placement = relY > height

        var {line, path} = this.props;
        var parent = path[path.length - 1];
        var id = e.dataTransfer.getData("text");

        if(parent && draggedObject && draggedObject != line.id){
            quark.sort_children(parent, draggedObject, line.id, placement)
            if(quark.dirty()){
                quark.checkpoint()
                globalUpdate()
            }
        }
    }

    render(){
        var {line, path} = this.props;
        
        if(line.type == 'inline_image'){
            return <img src={line.url} />
        }else if(line.type == 'checkbox'){
            return <div className="node-wrapper">
                <input type="checkbox" id="tugg" 
                    className="node-bullet" 
                    defaultChecked={!!localStorage.dark} 
                    style={{
                        marginLeft: 4,
                        marginRight: 5
                    }}
                    onChange={e => {
                        localStorage.dark = localStorage.dark ? '' : 'yes';
                        document.body.classList.toggle('dark-theme', !!localStorage.dark)
                    }} />
                <label htmlFor="tugg"><b>Dark Theme</b></label>
            </div>
        }else if(line.type == 'export'){
            var name = "hypernote-export-" + (new Date).toISOString().slice(0, 10) + ".json";
            return <div className="node-wrapper">
                <div className="node-self">
                    <div className="glyphicon glyphicon-download" style={{
                        marginRight: 17,
                        marginLeft: -10,
                        marginTop: 4
                    }} />
                    <div className="node">
                    <b>Export Data: </b>
                    <a href={URL.createObjectURL(new Blob([ JSON.stringify(entities) ]))}
                        download={name}
                    >{name}</a>
                    </div>
                </div>
            </div>
        }else if(line.type == 'toy-example'){
            return <div className="node-wrapper">
                <div className="node-self">
                    <div className="node-bullet" />
                    Hello world
                </div>
            </div>
        }else if(line.type == 'import'){
            return <div className="node-wrapper">
                <div className="node-self">
                    <div className="glyphicon glyphicon-upload" style={{
                        marginRight: 17,
                        marginLeft: -10,
                        marginTop: 4
                    }} />
                    <div className="node">
                    <b>Import Data: </b>
                    <input type="file" onChange={e => {
                        var fr = new FileReader()
                        fr.onload = function(){
                            try {
                                var obj = JSON.parse(fr.result);
                            } catch (err) {
                                alert("Could not parse file contents")
                            }
                            if(obj){
                                console.log(obj)
                                for(let id in obj){
                                    if(id != obj[id].id) continue;
                                    quark.core.set(id, obj[id]);
                                }
                                quark.checkpoint()
                                globalUpdate()
                                console.log('done adding')
                            }
                        }
                        fr.readAsText(e.target.files[0])
                    }}/>
                    </div>
                </div>
            </div>

           
        }else if(line.type == 'raw'){
            return <div className="node-wrapper">
                <div className="node-self">
                    <div className="node-bullet" />
                    {line.text}
                </div>
            </div>
        }else if(line.type == 'settings-text'){
            return <div className="node-wrapper">
                <div className="node-self">
                    <div className="node-bullet" />
                    <div className="node">
                        <SimpleHighlight text={line.text} />
                    </div>
                </div>
            </div>
        }else if(line.type == 'upgrade-body'){
            // return <PaymentForm />
        }
        
        var children = quark.get_children(line)
        var is_root = line.id == '__root__',
            has_children = children.length > 0,
            expanded = is_root || this.isExpand(),
            hover = this.isHover(),
            loop = this.loop(),
            boring;

        // TODO: figure out a better visual style to convey boringness

        if(line.type == 'cluster' && children.length == 1){
            boring = quark.is_empty(children[0].ref, line) ||
                    path.some(k => quark.line_is_equal(k, get(children[0].ref) ))
        }else if(line.type == 'edge'){
            boring = quark.is_empty(line.ref, line)
        }
        // classname helper
        function CN(...args){ return args.filter(x => x).join(' ') }


        var connectDragSource = (k => k),
            connectDropTarget = (k => React.cloneElement(k, {
                onDragStart: this.dragStart.bind(this),
                onDragEnd: this.dragEnd.bind(this),
                onDragOver: this.dragOver.bind(this),
                draggable: true
            }))

        if(is_root){
            connectDropTarget = (k => k);
        }

        return connectDropTarget(
            <div className={CN("node-wrapper", 
                is_root && "current-root", 
                draggedObject == line.id && 'is-dragging')}>
                <div className="node-self">
                    {connectDragSource(<div className={CN(
                            "node-bullet", 
                            has_children && !boring && !expanded && 'parent', 
                            !loop && expanded && has_children && hover && 'collapse',
                            !loop && !expanded && has_children && hover && 'expand',
                            loop && 'loop',
                            boring && 'boring'
                        )}
                        title={line.created ? moment(line.created).fromNow() : 'no date'}
                        onClick={this.toggleCollapse.bind(this)}
                        onMouseEnter={this.bulletEnter.bind(this)}
                        onMouseLeave={this.bulletLeave.bind(this)} />)}
                    {this.render_node()}
                </div>
                <div className="node-children">{
                    expanded ? this.render_children(children) : null
                }</div>
            </div>
        )
    }
}

function SimpleHighlight(props){
    var tokens = [],
        text = props.text,
        m;

    while(text.length > 0){
        if(m = /^.*?\=/.exec(text)){
            tokens.push(<b key={m[0]}>{m[0]}</b>)
            text = text.slice(m[0].length)
        }else if(m = /^http:\/\/.*/.exec(text)){
            tokens.push(<a key={m[0]} target="_blank" href={m[0]}>{m[0]}</a>)
            text = text.slice(m[0].length)
        }else{
            tokens.push(text[0])
            text = text.slice(1)
        }    
    }
    
    return <span>{tokens}</span>
}



// WEBPACK FOOTER //
// ./src/react/Lombax.jsx